<div class="row page-title-header modal-header m-0" style="background-color: #1363Df !important;">
  <div class="col-md-11 col-11 text-center">
    <span class="title">Select Preference</span>
  </div>
  <div class="col-md-1 col-1 pull-right p-0">
    <a class="close link" (click)="close()">&times;</a>
  </div>
</div>
<div style="padding: 20px 15px 0;">

  <mat-form-field style="width: 100%" appearance="fill" class="matFformFieldClient">
    <mat-label>Client</mat-label>
    <mat-select [(ngModel)]="selectedClient" (selectionChange)="onClientChange()">
      <mat-option style="font-family: 'Poppins';" *ngFor="let client of clients" [value]="client">
        {{ client.client_nm }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field style="width: 100%" appearance="fill" class="matFformFieldClient">
    <mat-label>Brand</mat-label>
    <mat-select [(ngModel)]="selectedBrand" (selectionChange)="getProcessTypes()" [disabled]="!selectedClient">
      <mat-option style="font-family: 'Poppins';" *ngFor="let brand of brands" [value]="brand">
        {{ brand.brand_key }} - {{ brand.brand_nm }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field style="width: 100%" appearance="fill" class="matFformFieldClient">
    <mat-label>Process Type</mat-label>
    <mat-select [(ngModel)]="selectedProcessName" [compareWith]="compareProcess" [disabled]="!selectedBrand">
      <mat-option style="font-family: 'Poppins';" *ngFor="let process of processNames" [value]="process">
        {{ process.process_typ_nm }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>


<!-- <div class="row">
  <div class="col-12 text-center my-4">
    <span *ngIf=" !selectedBrand && !selectedProcessName" class="error-msg">Nothing has been
      selected</span>
    <span *ngIf="selectedBrand" class="error-msg">Selected Values: {{
      selectedBrand?.brand_nm || 'N/A' }} / {{ selectedProcessName?.workflow_typ || 'N/A' }}</span>
  </div>
</div> -->

<div class="row">
  <div class="col-12 text-center my-4">
    <button type="button" class="btn btn-primary btn-sm confirmBtnHomePopups btn-confirm" matTooltip="Confirm"
      matTooltipClass="expand-tooltip" [disabled]="!selectedClient || !selectedBrand || !selectedProcessName" (click)="clientSelection()">
      Confirm
    </button>
  </div>
</div>
